function validatePhone(el) {
  var form = $(el).closest("form");
  $(form).validate({
    rules: {
      "question[phone]": {
        phonelength: true
      }
    },
    errorClass: "form-error",
    errorElement: "span"
  });
}

function initPhoneValidations() {
  $(".phone-tooltip-validation").each(function () {
    validatePhone(this);
  });
}

$(function () {
  initPhoneValidations();
});